// client/src/pages/LearningHub.tsx

import React, { useState, useEffect } from "react";
import { getContent } from "../services/learningService";
import "../assets/styles/pages.css";

const LearningHub: React.FC = () => {
  const [content, setContent] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      try {
        const data = await getContent();
        setContent(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  return (
    <div className="page learninghub-page">
      <h2>Learning Hub</h2>
      {loading ? (
        <p>Loading content...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <div>
          <p>{content}</p>
        </div>
      )}
    </div>
  );
};

export default LearningHub;
